// src/pages/Instruction/Instruction.tsx
import React from 'react';
import './Instruction.css';

const Instruction: React.FC = () => {
  return (
    <main className="instruction-page other-page">
      <h1>初回利用時導入マニュアル</h1>
      <p>
        このマニュアルでは、公式LINEチャネルと本アプリを連携し、Webhookを設定するまでの初期導入手順を解説します。
      </p>

      {/* Section 1 */}
      <h2 style={{ marginTop: '1.5rem' }}>1. LINEチャネル情報の取得と設定</h2>
      <ol style={{ paddingLeft: '1.25rem' }}>
        <li><a href="https://developers.line.biz/console/" target='_blank' rel="noreferrer">LINE Developers</a> にアクセスし、LINEアカウントでログインします。</li>
        <li>プロバイダーを未作成の場合は新規に作成します。</li>
        <li>
          「Messaging API」チャネルを新規作成します。
          <br />
          チャネル名など必要事項を入力し、作成を完了させてください。
        </li>
        <li>
          チャネル設定画面に移動し、以下の3点を取得します。
          <ul style={{ paddingLeft: '1.25rem', listStyleType: 'disc' }}>
            <li>チャネルID (Channel ID)</li>
            <li>チャネルシークレット (Channel Secret)</li>
            <img
              src="/assets/images/inst1.jpg"
              alt="Webhook URL 設定画面"
            />
            <li>チャネルアクセストークン (Channel Access Token)</li>
          </ul>
        </li>
        <li>長期(ロングターム)アクセストークンを発行してください。</li>
        <li>
          取得した情報をアプリ管理画面「LINE・チャネル設定」のフォームに入力し、保存します。
        </li>
        <img
              src="/assets/images/inst1-2.jpg"
              alt="アプリ設定画面"
            />
      </ol>

      <pre
        style={{
          background: '#f6f8fa',
          padding: '0.75rem',
          borderRadius: '4px',
          overflowX: 'auto',
        }}
      >
        {`チャネルID: xxxxxxxxxx
チャネルシークレット: xxxxxxxxxx
アクセストークン: xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx`}
      </pre>

      {/* Section 2 */}
      <h2 style={{ marginTop: '1.5rem' }}>2. Webhook URLの設定</h2>
      <ol style={{ paddingLeft: '1.25rem' }}>
        <li>アプリ管理画面「LINE・チャネル設定」に表示されている 「Webhook URL」 をコピーします。</li>
        <li>
          LINE Developers
          にアクセスし、該当の公式アカウントを選択してログインします。
        </li>
        <li>タブの「Messaging API設定」を開きます。</li>
        <li>
          「Webhook
          URL」欄にコピーしたURLを貼り付け「更新」ボタンをクリックします。
        </li>
        <li>
          「検証」ボタンをクリックして「成功」と表示されたら接続完了です。
        </li>
        <li>「Webhookの利用」のトグルをONに切り替えます。</li>
        <li>アプリ管理画面「LINE・チャネル設定」の「AIによる自動応答を実行」のトグルボタンをオンにします。</li>
        <li>アプリ管理画面「LINE・チャネル設定」最下部の「更新」をクリックして設定を更新します。</li>
      </ol>

      <img
        src="/assets/images/inst2.jpg"
        alt="Webhook URL 設定画面"
      />

      {/* Section 3 */}
      <h2 style={{ marginTop: '1.5rem' }}>3. 動作確認</h2>
      <ol style={{ paddingLeft: '1.25rem' }}>
        <li>
          テストメッセージを公式LINEに送信し、Botからの自動応答が返ってくるか確認してください。
        </li>
        <li>
          必要に応じてアプリ管理画面の「自動応答設定」&gt;「AI自動応答用プロンプト
          (200文字以内)」にBotの応答形式を指定してください。
        </li>
      </ol>

      {/* Section 4 */}
      <h2 style={{ marginTop: '1.5rem' }}>4. トラブルシューティング</h2>

      <dl>
        <dt style={{ fontWeight: 'bold', marginTop: '1rem' }}>
          チャネルアクセストークンが発行できない
        </dt>
        <dd style={{ marginLeft: '1.25rem' }}>
          ロングタームトークン発行ボタンを押したあと、権限設定が不足している可能性があります。チャネル設定画面の権限タブを確認し、botの発言権限がONになっているか確認してください。
        </dd>

        <dt style={{ fontWeight: 'bold', marginTop: '1rem' }}>
          Webhookテストが失敗する
        </dt>
        <dd style={{ marginLeft: '1.25rem' }}>
          URLの末尾に余分なスラッシュ（/）やスペースが含まれていないか確認してください。
        </dd>

        <dt style={{ fontWeight: 'bold', marginTop: '1rem' }}>
          自動応答が返ってこない
        </dt>
        <dd style={{ marginLeft: '1.25rem' }}>
          BotのWebhook送信設定をONにした後、Botの動作ロジック（イベントハンドラー）が正しく動作しているか、ログ出力を確認してください。
        </dd>
      </dl>
    </main>
  );
};

export default Instruction;
